import type { Action } from 'state/actions';
import { addOrReplaceKey, patchKey } from 'state/utils/collection';

import type { DlpProductMap } from './dlpProduct.model';
import { initialDlpProductMap } from './dlpProduct.model';

export function dlpProductReducer(state: DlpProductMap = initialDlpProductMap, action: Action): DlpProductMap {
  switch (action.type) {
    case 'SECONDARY_MARKET_DLP_PRODUCT_FETCH_REQUESTED':
      return addOrReplaceKey(state, action.isin, { isLoading: true, hasError: false, data: null });
    case 'SECONDARY_MARKET_DLP_PRODUCT_FETCHED':
      return patchKey(state, action.isin, () => ({
        isLoading: false,
        hasError: false,
        data: {
          ...action.data,
        },
      }));
    case 'SECONDARY_MARKET_DLP_PRODUCT_FETCH_PRODUCT_NOT_FOUND':
    case 'SECONDARY_MARKET_DLP_PRODUCT_FETCH_FAILED':
      return patchKey(state, action.isin, () => ({ isLoading: false, hasError: true, data: null }));
    default:
      return state;
  }
}
